import styled, { createGlobalStyle } from 'styled-components';
import { QUALITY_MARK_ASPECT_RATIO, breakpoints } from 'config/config';

export const FarmGlobalStyle = createGlobalStyle`
  @media (max-width: ${breakpoints.xs}px) {
    .mobile-header-container .buy-latvia-food {
      display: none !important;
    }
  }
  `;

export const StyledFarmView = styled.div`
  background-color: ${(props) => props.theme.white};

  .breadcrumbs-container {
    padding: 23px 0;
  }

  .breadcrumbs-container {
    display: flex;
    justify-content: space-between;

    .breadcrumb {
      cursor: pointer;
    }

    div {
      span {
        a {
          text-decoration: none;
          color: ${(props) => props.theme.black};
        }
      }
    }
  }

  .farm-details {
    padding: 15px 200px;
  }

  .farm-members {
    display: flex;
    align-items: center;
    gap: 10px;

    img {
      width: 24px;
      height: 21px;
    }
  }

  .working-time-container {
    padding: 20px;
    background-color: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.lightGrey};

    p {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }

  .working-time {
    display: flex;
    flex-direction: column;
    width: 400px;

    @media (max-width: ${breakpoints.xs}px) {
      width: 100%;
    }
  }

  .day-time-row {
    display: flex;
    max-width: 320px;

    @media (max-width: ${breakpoints.xs}px) {
      max-width: 100%;
    }
  }

  .day-name {
    display: block;
    width: 120px;
  }

  .day-name,
  .day-time {
    padding: 12px 15px;
    font-size: 17px;
    font-weight: 400;
  }

  .content-section {
    padding: 40px 0;
  }

  .popular-products {
    padding: 40px 0 61px 0;

    h1 {
      margin-top: 0;
    }

    .desktop-products-container .title,
    .grid-view {
      padding: 0 !important;
      justify-content: center;
      gap: 30px;
    }

    .title h1 {
      margin-top: 0;
      margin-bottom: 36px;
      font-weight: 500;
      font-size: 42px;
    }
  }

  .grid-view {
    row-gap: 30px;
  }

  .menu-products,
  .mobile-menu-container {
    display: none;
    @media (max-width: ${breakpoints.xs}px) {
      display: block;

      background-color: ${(props) => props.theme.brightGrey};

      .mobile-back {
        background-color: ${(props) => props.theme.white};
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 47px 15px 17px 16px;
        margin-top: 2px;
        border-radius: 10px 10px 0 0;
        border-bottom: 1px solid ${(props) => props.theme.lightGrayBorder};

        .back-icon,
        img {
          width: 17px;
          height: 17px;
        }

        .back-text {
          font-size: 0.875rem !important;
          line-height: 16px;
        }
      }

      .custom-menu {
        display: flex;
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .custom-menu-item {
        padding: 10px;
        cursor: pointer;
        color: ${(props) => props.theme.grey};
        font-size: 1rem;
        font-weight: 500;
      }

      .custom-menu-item.active {
        color: ${(props) => props.theme.black};
      }

      .content-section {
        padding: 10px;

        .other-products-container {
          margin-bottom: 20px;
        }
      }

      .custom-menu::-webkit-scrollbar {
        height: 4px;
      }
      ul {
        background-color: ${(props) => props.theme.white};
      }
    }
  }

  .banners {
    .slick-slider {
      margin-bottom: 0;
    }

    .banner-wrapper {
      padding: 100px 0 60px 0;
    }

    .banner-image-wrapper {
      padding: 0;
    }

    .slick-dots-bottom {
      bottom: -32px;
    }
  }

  @media (max-width: 1400px) {
    .farm-details {
      padding: 15px 50px;
    }
  }
  @media (max-width: 845px) {
    .farm-details {
      padding: 20px;
    }
  }
  @media (max-width: ${breakpoints.xs}px) {
    padding: 0;
    background-color: ${(props) => props.theme.inputGrey};

    .laptop-search-section-box {
      display: none;
    }

    .content-section {
      padding: 0 !important;

      .contact_name {
        padding: 20px;
      }
    }

    .desktop-content {
      display: none;
    }

    .menu-container {
      display: none;
    }

    .product-description {
      margin: 20px 0;
      padding: 5px 10px;
      border: 1px solid ${(props) => props.theme.darkRed};
      border-radius: 5px;
      color: ${(props) => props.theme.colorText};
      font-family: ${(props) => props.theme.fontText};
      font-size: 1rem;
      line-height: 22px;
      font-weight: 300;

      .font-weight-500 {
        font-weight: 500;
      }
    }

    .popular-products {
      padding: 0;
      background-color: ${(props) => props.theme.brightGrey};

      .title {
        padding: 0 !important;
      }

      .title h1 {
        margin-top: 0;
      }

      .grid-view {
        row-gap: 15px;
      }

      .price-type-container {
        font-size: 1rem;
        font-weight: 500;
        line-height: 19px;
      }
    }

    .mobile-description {
      padding: 20px;
    }

    .mobile-farm-services-wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 20px;

      .mobile-farm-services-title {
        font-size: 1rem;
        font-weight: 500;
      }

      .mobile-farm-services-container {
        display: flex;
        margin-top: 8px;
        flex-wrap: wrap;

        .mobile-farm-service-tag {
          background-color: ${(props) => props.theme.farmServiceTagBorderColor};
          color: ${(props) => props.theme.white};
          border-radius: 36px;
          border: none;
          padding: 2px 8px;
          font-family: ${(props) => props.theme.fontText};
          margin-bottom: 8px;
        }
      }
    }

    .farm-details {
      display: none;
    }

    .desktop-products-container {
      display: none;
    }

    .mobile-farm-info {
      margin: 0 20px 10px;
      padding: 10px 20px;
      border-radius: 8px;
      background-color: ${(props) => props.theme.white};
      .mobile-title {
        font-size: 18px;
      }

      .mobile-info-div {
        .info-column {
          display: flex;
          gap: 15px;
          align-items: center;
          border-bottom: 1px solid ${(props) => props.theme.lightGrey};
          color: ${(props) => props.theme.black};
          font-weight: 400;
          padding: 12px 0;

          .address-list {
            display: flex;
            flex-direction: column;
          }

          &.contact-name {
            font-weight: 500;
          }

          > div:has(> img) {
            display: flex;
          }
        }

        .info-column a {
          margin: 0;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          max-width: 100%;
          color: ${(props) => props.theme.black};
          text-decoration: underline;
        }

        .bookmark {
          display: flex;
          flex-direction: column;
          .bookmark-2 {
            display: flex;
            align-items: center;
            gap: 15px;
            padding: 12px 0;
          }
        }
        .mobile-nums {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin: 0;
        }
      }

      .mobile-buttons {
        display: flex;
        justify-content: center;
        gap: 10px;

        a {
          width: 100%;
          padding: 5px 0;

          button {
            width: 100%;
            height: 30px;
            font-family: ${(props) => props.theme.fontText};
          }
        }
      }
    }

    .banners {
      .banner-wrapper {
        padding-top: 0;
        padding-bottom: 0;
      }

      .slick-dots-bottom {
        display: none !important;
      }
    }
  }

  .farm-info {
    padding-top: 30px;
    display: flex;
    padding-top: 40px;

    .farm-img-box {
      height: fit-content;
      align-self: center;
      min-width: 200px;
      width: 200px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 30px;
      border: 1px solid ${(props) => props.theme.lightGrey};
      border-radius: 5px;

      @media (max-width: 545px) {
        min-width: auto;
        width: 350px;
        display: flex;
        justify-content: center;
      }

      @media (max-width: ${breakpoints.xs}px) {
        width: 100%;
        gap: 15px;
        background-color: ${(props) => props.theme.white};
        border: none;
      }

      img {
        overflow: hidden;
      }

      .cooperative-badge {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 50%);
        z-index: 1;
        width: 52px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        border: 1px solid ${(props) => props.theme.brand02};
        background-color: ${(props) => props.theme.white};
        overflow: hidden;

        img {
          width: 70%;
          height: 70%;
          object-fit: contain;
        }
      }

      .farm-tags {
        position: absolute;
        top: 10px;
        left: 0;
        margin: 0 10px;

        .top-farm {
          border-radius: 6px;
          display: flex;
          align-items: center;
          font-size: 12px;
          background-color: ${({ theme }) => theme.topPriceBgColor};
          color: ${({ theme }) => theme.white};
          padding: 5px;
        }
      }

      .logos {
        display: none;
        flex-wrap: wrap;

        @media (max-width: ${breakpoints.xs}px) {
          display: flex;
          gap: 8px;
        }

        img {
          width: 70px;
          height: auto;
          aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};
          object-fit: contain;

          @media (max-width: ${breakpoints.xs}px) {
            width: 36px;
            margin: 0 5px 11px;
          }
        }
      }
    }
    h1 {
      font-size: 18px;
      margin: 15px 20px;
      font-weight: 500;
    }

    @media (max-width: 545px) {
      flex-direction: column;
    }

    .farm-title h1 {
      margin: 0;
      font-family: ${(props) => props.theme.fontText};
      font-size: 42px;
      font-weight: 500;

      @media (max-width: ${breakpoints.lg}px) {
        font-size: 20px;
      }
      @media (max-width: ${breakpoints.xs}px) {
        font-size: 18px;
      }
    }

    .farm-services-container {
      margin-top: 8px;

      .farm-service-tag {
        background-color: transparent;
        color: ${(props) => props.theme.black};
        border-radius: 40px;
        border: 1px solid ${(props) => props.theme.tagBorderColor};
        padding: 5px 10px;
        font-family: ${(props) => props.theme.fontText};
        margin-bottom: 8px;
      }
    }
    .farm-contact {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 70px;
      width: 100%;
      padding-left: 50px;

      @media (max-width: 845px) {
        padding: 0 20px;
      }
      @media (max-width: 545px) {
        padding: 0;
        margin-top: 50px;
      }

      .farm-title {
        display: flex;
        justify-content: space-between;

        .mobile-website-box {
          display: none;

          @media (max-width: ${breakpoints.lg}px) {
            display: block;
          }

          .mobile-website {
            display: flex;
            flex-direction: column;
            gap: 10px;
            a {
              text-decoration: underline;
              cursor: pointer;
              color: ${(props) => props.theme.black};
            }
            div {
              display: flex;
              gap: 20px;
            }
          }
        }

        @media (max-width: ${breakpoints.lg}px) {
          flex-direction: column;
          gap: 30px;
        }
        @media (max-width: 545px) {
          gap: 10px;
        }
        @media (max-width: ${breakpoints.xs}px) {
          padding: 0 20px;
        }
      }

      .logos {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;

        img {
          width: 70px;
          height: auto;
          aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};
          object-fit: contain;

          @media (max-width: ${breakpoints.xs}px) {
            width: 36px;
          }
        }

        .quality-mark-wide {
          margin-inline: 9px;

          @media (max-width: ${breakpoints.xs}px) {
            margin-inline: 5px;
          }
        }
      }
    }
    @media (max-width: ${breakpoints.xs}px) {
      padding-top: 0;
    }
  }
  .menu-container {
    padding-top: 80px;

    .ant-menu-title-content {
      font-family: ${(props) => props.theme.fontText};
    }

    .ant-menu-horizontal {
      border-bottom: 0;
    }

    .menu-line {
      margin: 0;
      height: 1px;
      background-color: ${(props) => props.theme.borderBottom};
      border: 0;
    }

    .ant-menu-item {
      padding-left: 0;
    }

    .ant-menu-item::after {
      left: 0;
    }

    ul li span:not(.anticon) {
      font-weight: 500;
      color: ${(props) => props.theme.grey};
    }

    .slick-arrow {
      width: 44px;
      height: 44px;
      background-color: ${(props) => props.theme.white};
      border-radius: 4px;
      color: ${(props) => props.theme.black2};
      opacity: 1;
    }

    .slick-prev {
      left: -55px;
    }

    .slick-next {
      right: -55px;
    }

    .slick-prev::after,
    .slick-next::after {
      left: 16px;
      top: 16px;
    }

    @media (max-width: 845px) {
      padding-top: 30px;
    }
    @media (max-width: ${breakpoints.xs}px) {
      padding-top: 20px;
      order: -1;
      padding: 0 20px;

      ul {
        width: 100vw;

        &::before,
        &::after {
          display: none;
        }
      }
    }

    .content-section {
      padding: 34px 0 70px 0;

      .title,
      .grid-view {
        padding: 0;
      }

      @media (max-width: ${breakpoints.xs}px) {
        padding: 32px 0 51px 0;
      }
    }
  }
  .farm-datas {
    display: flex;
    justify-content: space-between;
    margin-top: -50px;

    @media (max-width: ${breakpoints.lg}px) {
      display: none;
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 10px 25px;
      padding-bottom: 0;
      width: 100%;
      border-left: 1px solid ${(props) => props.theme.borderBottom};
      height: 100%;
      margin: 0;

      li {
        display: flex;
        gap: 5px;
        list-style: none;
        font-weight: 400;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          width: 16px;
          height: 16px;
        }
        a {
          color: ${(props) => props.theme.black};

          button {
            padding: 0 30px;
          }
        }
      }

      li:hover {
        background-color: transparent;
      }
    }

    ul:nth-child(1) {
      border: none;
      padding: 10px 50px 10px 0;
    }
  }
  .mobile-farm-datas-div {
    display: none;

    @media (max-width: ${breakpoints.lg}px) {
      display: block;
    }
    @media (max-width: 845px) {
      display: none;
    }
  }
  .mobile-farm-datas {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    padding: 0 20px;

    ul {
      display: flex;
      flex-direction: column;
      align-items: start;
      padding: 10px 50px;
      width: 100%;
      border-left: 1px solid ${(props) => props.theme.borderBottom};
      height: 100%;
      margin: 0;

      li {
        display: flex;
        gap: 5px;
        align-items: center;
        list-style: none;
        font-weight: 400;
        a {
          color: ${(props) => props.theme.black};
        }
      }
    }

    @media (max-width: ${breakpoints.lg}px) {
      ul:nth-child(4) {
        display: none;
      }
    }

    ul:nth-child(1) {
      border: none;
      padding: 10px 50px 10px 0;
    }
    ul:nth-child(4) {
      padding: 10px 0 10px 50px;
    }
  }
  .farm-description {
    margin-top: 50px;
  }

  .ant-menu-item-selected {
    &::after {
      border-bottom-color: ${(props) => props.theme.black} !important;
    }

    .ant-menu-title-content {
      color: ${(props) => props.theme.black};
    }
  }

  .ant-menu-item:hover {
    &::after {
      border-bottom-color: ${(props) => props.theme.black} !important;
    }

    .ant-menu-title-content {
      color: ${(props) => props.theme.black};
    }
  }

  .desktop-products-container {
    padding-bottom: 73px;
    background-color: ${(props) => props.theme.containerBgColor};
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .farm-info {
      h1 {
        font-size: 1.125rem;
      }

      .mobile-info-div {
        .info-column {
          font-size: 1rem;
        }

        .bookmark {
          font-size: 1rem;
        }
      }

      .mobile-description {
        font-size: 1rem;
      }
    }
  }
`;

export const RatingsTabLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledRate = styled.div`
  .ant-rate {
    font-size: 14px;
  }
`;
